import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AppComponent } from '../component';
import rp from '@reporting/rp-app-host';
import { AccountingRights } from '@reporting/rp-types/core';
import { msg } from '@omegagrid/localize';

@customElement('rp-app-menu')
export class AppMenu extends AppComponent {

	static styles = css`
		* {
			box-sizing: border-box;
		}

		:host {
			height: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			line-height: 1;
		}

		:host > * {
			min-width: 40px;
			text-align: center;
			height: 100%;
		}
	`;

	@property({type: Boolean})
	compact = false;

	private dialogSize: { w: number, h: number } = { w: 800, h: 600 };

	async firstUpdated() {
		if (window.innerWidth < this.dialogSize.w) {
			this.dialogSize.w = window.innerWidth - (rp.host.bucket.compact ? 0 : 40);
		}
		if (window.innerHeight < this.dialogSize.h) {
			this.dialogSize.h = window.innerHeight - (rp.host.bucket.compact ? 0 : 40);
		}
	}

	async _openJournal() {
		// passed as `component`, not `id`: a popup must not be saved in the bucket state and reopened after reload
		const component = await rp.host.createComponent('accounting-journal-compact');
		const dialog = await rp.host.openDialog({
			component,
			caption: msg('Journal'),
			closable: true,
			maximizable: true,
			resizable: true,
			location: 'center',
			width: this.dialogSize.w,
			height: this.dialogSize.h,
		});

		// a click anywhere outside the dialog closes it
		const onPointerDown = (e: PointerEvent) => {
			if (!e.composedPath().includes(dialog)) dialog.close();
		};
		document.addEventListener('pointerdown', onPointerDown, true);
		dialog.addEventListener('dialog.close', () => {
			document.removeEventListener('pointerdown', onPointerDown, true);
		}, { once: true });
	}

	render = () => rp.userProvider.isGuest() ? '' : html`
		<rp-app-jobwatcher .app="${this.app}" ?compact="${this.compact}"></rp-app-jobwatcher>

		${this.compact ? null : html`
			${rp.userProvider?.hasRight(AccountingRights.Admin) ? html`
				<og-button
					@click="${() => this._openJournal()}"
					icon="reel"
					color="transparent">
				</og-button>
			` : null}

			<rp-app-helpmenu></rp-app-helpmenu>
		`}
			
		<rp-app-usermenu .app="${this.app}" ?compact="${this.compact}"></rp-app-usermenu>
	`;

}
